// Or from '@reduxjs/toolkit/query' if not using the auto-generated hooks
import {
  BaseQueryFn,
  createApi,
  FetchArgs,
  fetchBaseQuery,
  FetchBaseQueryError,
} from '@reduxjs/toolkit/query/react';

// Custom baseQuery to handle 401/403 globally
const rawBaseQuery = fetchBaseQuery({
  baseUrl: process.env.REACT_APP_API_BASE!,
  credentials: 'include',
  prepareHeaders: (headers) => {
    if (process.env.REACT_APP_DISABLE_LOGIN == 'true') {
      headers.set('Mock-User', localStorage.getItem('local_user_id')!);
    }
  },
});

// Track if we're currently attempting a refresh to prevent infinite loops
let isRefreshing = false;

const baseQueryWithAuth: BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError> = async (
  args,
  api,
  extraOptions,
) => {
  const result = await rawBaseQuery(args, api, extraOptions);

  if (result.error && (result.error.status === 401 || result.error.status === 403)) {
    // Don't attempt refresh if we're already refreshing or if this is a refresh request
    const isRefreshRequest = typeof args === 'object' && args.url === '/auth/refresh';

    if (!isRefreshing && !isRefreshRequest) {
      console.log('Authentication failed, attempting session refresh...');
      isRefreshing = true;

      try {
        const refreshResult = await rawBaseQuery(
          { url: '/auth/refresh', method: 'POST' },
          api,
          extraOptions,
        );

        // If refresh was successful, refresh the page
        if (!refreshResult.error) {
          console.log('Session refreshed successfully, refreshing page');
          isRefreshing = false;
          window.location.reload();
          // Return a successful result to keep UI in loading state
          return { data: null };
        } else {
          console.log('Session refresh failed with error:', refreshResult.error);
          window.location.assign('/login');
        }
      } catch (refreshError) {
        console.log('Session refresh failed with exception:', refreshError);
        window.location.assign('/login');
      } finally {
        isRefreshing = false;
      }
    }
  }

  return result;
};

// initialize an empty api service that we'll inject endpoints into later as needed
export const emptyApi = createApi({
  baseQuery: baseQueryWithAuth,
  endpoints: () => ({}),
});
